<template>
  <md-app md-mode="fixed">
    <md-app-drawer md-permanent="full">
      <admin-sidebar></admin-sidebar>
    </md-app-drawer>
    <md-app-content>
      <router-view></router-view>
    </md-app-content>
  </md-app>
</template>

<script>
  import AdminSidebar from "./admin/AdminSidebar";

  export default {
    name      : "AdminLayout",
    components: {AdminSidebar},
  }
</script>

<style lang="scss" scoped>
  @import "src/assets/scss/backend.scss";
  @import "src/assets/scss/components.scss";
</style>
